const VARIANT_CLASSES = {
    default: 'bg-mps-blue-600 hover:bg-mps-blue-700 focus:ring-mps-blue-500',
    danger: 'bg-red-600 hover:bg-red-700 focus:ring-red-500',
    warning: 'bg-yellow-500 hover:bg-yellow-600 focus:ring-yellow-400 text-gray-900',
};

const OVERLAY_ID = 'iphub-confirm-dialog-overlay';

function removeExistingOverlay() {
    const existing = document.getElementById(OVERLAY_ID);
    existing?.remove();
}

function createDialogMarkup({
    title,
    message,
    confirmText,
    cancelText,
    type,
}) {
    const variantClass = VARIANT_CLASSES[type] || VARIANT_CLASSES.default;
    return `
        <div id="${OVERLAY_ID}" class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4" role="dialog" aria-modal="true">
            <div class="w-full max-w-md overflow-hidden rounded-lg bg-white shadow-xl transform transition-all">
                <div class="px-6 pt-6">
                    <h3 class="text-lg font-semibold text-gray-900">${title}</h3>
                </div>
                <div class="px-6 py-4 text-sm text-gray-600">
                    ${message}
                </div>
                <div class="flex justify-end gap-3 px-6 pb-6">
                    <button type="button" data-dialog-action="cancel"
                        class="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400">
                        ${cancelText}
                    </button>
                    <button type="button" data-dialog-action="confirm"
                        class="rounded-md px-4 py-2 text-sm font-semibold text-white focus:outline-none focus:ring-2 focus:ring-offset-2 ${variantClass}">
                        ${confirmText}
                    </button>
                </div>
            </div>
        </div>
    `;
}

export function showConfirmDialog({
    title = 'Xác nhận',
    message = 'Bạn có chắc chắn?',
    confirmText = 'Xác nhận',
    cancelText = 'Hủy',
    type = 'default',
} = {}) {
    return new Promise((resolve) => {
        removeExistingOverlay();

        const template = document.createElement('div');
        template.innerHTML = createDialogMarkup({
            title,
            message,
            confirmText,
            cancelText,
            type,
        }).trim();

        const overlay = template.firstElementChild;
        if (!overlay) {
            resolve(false);
            return;
        }

        document.body.appendChild(overlay);

        const cleanup = () => {
            overlay.removeEventListener('click', handleOverlayClick);
            overlay.removeEventListener('keydown', handleKeydown);
            overlay.querySelectorAll('button').forEach((btn) => {
                btn.removeEventListener('click', handleButtonClick);
            });
            overlay.remove();
        };

        const settle = (result) => {
            cleanup();
            resolve(result);
        };

        const handleButtonClick = (event) => {
            const action = event.currentTarget.getAttribute('data-dialog-action');
            settle(action === 'confirm');
        };

        const handleOverlayClick = (event) => {
            if (event.target === overlay) {
                settle(false);
            }
        };

        const handleKeydown = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                settle(false);
            }
            if (event.key === 'Enter') {
                event.preventDefault();
                const confirmButton = overlay.querySelector('[data-dialog-action="confirm"]');
                confirmButton?.click();
            }
        };

        overlay.querySelectorAll('button').forEach((btn) => {
            btn.addEventListener('click', handleButtonClick);
        });
        overlay.addEventListener('click', handleOverlayClick);
        overlay.addEventListener('keydown', handleKeydown);

        const confirmButton = overlay.querySelector('[data-dialog-action="confirm"]');
        confirmButton?.focus();
    });
}

export default showConfirmDialog;

